export function toAgriGeoJSON(data) {
  const features = [
    {
      type: "Feature",
      properties: {
        type: "PATH",
        routeId: data.id,
      },
      geometry: {
        type: "LineString",
        coordinates: data.waypointDetails.map((p) => [p.x, p.y, p.z]),
      },
    },
  ];

  // 헤드랜드 폴리곤 추가 (있는 경우)
  if (
    data.headlandData?.headland &&
    Array.isArray(data.headlandData.headland)
  ) {
    features.push({
      type: "Feature",
      properties: {
        type: "HEADLAND",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          // 폴리곤 닫기 (첫 점과 마지막 점이 같아야 함)
          data.headlandData.headland.length > 0 &&
          data.headlandData.headland[0][0] !==
            data.headlandData.headland[data.headlandData.headland.length - 1][0]
            ? [...data.headlandData.headland, data.headlandData.headland[0]]
            : data.headlandData.headland,
        ],
      },
    });
  }

  // 작업 영역 폴리곤 추가 (있는 경우)
  if (
    data.workAreaPolygon &&
    Array.isArray(data.workAreaPolygon) &&
    data.workAreaPolygon.length > 0
  ) {
    features.push({
      type: "Feature",
      properties: {
        type: "WORK_AREA",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          // 폴리곤 닫기 (첫 점과 마지막 점이 같아야 함)
          data.workAreaPolygon.length > 0 &&
          data.workAreaPolygon[0][0] !==
            data.workAreaPolygon[data.workAreaPolygon.length - 1][0]
            ? [...data.workAreaPolygon, data.workAreaPolygon[0]]
            : data.workAreaPolygon,
        ],
      },
    });
  }

  // 장애물 추가 (있는 경우)
  if (data.obstacles && Array.isArray(data.obstacles)) {
    features.push(
      ...data.obstacles.map((obs) => ({
        type: "Feature",
        properties: {
          type: "OBSTACLE",
          obstacleId: obs.id,
          name: obs.name,
          areaTypeId: obs.areaType?.id,
          areaTypeName: obs.areaType?.typeName,
          areaTypeColor: obs.areaType?.typeColor,
          description: obs.description,
        },
        geometry: {
          type: "Polygon",
          coordinates: [obs.points.map((pt) => [pt.x, pt.y, pt.z])],
        },
      })),
    );
  }

  return {
    type: "FeatureCollection",
    properties: {
      projectId: data.projectId,
      routeId: data.id,
      name: data.name,
      workType: data.workType,
      description: data.description,
      createdAt: data.createdAt,
      createdBy: data.createdByName,
      equipment: {
        id: data.agriculturalEquipmentId,
        name: data.agriculturalEquipmentName,
        width: data.equipmentSpec?.width,
        wheelbase: data.equipmentSpec?.wheelbaseL,
        steerDeg: data.equipmentSpec?.steerDeg,
        turningRadius: data.equipmentSpec?.turningRadius,
      },
      // 검증용 제약 조건 정보
      constraints: {
        // 1. 회전 반경 준수 여부 판단용
        turningRadius: data.equipmentSpec?.turningRadius, // 최소 회전 반경 (m)
        // 2. 안전 마진 준수 여부 판단용
        safetyMargin: data.safetyMargin ?? 0.1, // 안전 마진 (m)
        // 3. 차량 폭 경계 준수 여부 판단용
        vehicleWidth: data.equipmentSpec?.width, // 차량 폭 (m)
      },
    },
    features,
  };
}
